import {ReactElement} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../use-auth';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import { Role } from '@common/auth/user';

interface Props {
  children?: ReactElement;
  permission?: string;
  requireLogin?: boolean;
}
export function AdminAuthRoute({
  children,
  permission,
  requireLogin = true,
}: Props) {
  const {isLoggedIn, user} = useAuth();

  // console.log('isLoggedIn', isLoggedIn);

  const admin = user?.role == Role.ADMIN || user?.role == Role.VENDOR || user?.role == Role.STAFF;

  if (requireLogin && !isLoggedIn) {
    if (isLoggedIn) {
      return <NotFoundPage />;
    }

    // if (admin) {
    //   return <Navigate to="/" replace />;
    // }

    return <Navigate to="/admin/login" replace />;
  }

  if (!admin) {
    return <Navigate to="/" replace />;
  }
  return children || <Outlet />;
}
